import React, { useState, useEffect } from 'react';
import './Orders.css';
import { useNavigate } from 'react-router-dom';

const Orders = () => {
  const [orders, setOrders] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('auth-token');
    if (token) {
      fetch('http://localhost:4000/orders', {
        headers: { 'auth-token': token }
      })
        .then(res => {
          if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
          return res.json();
        })
        .then(data => {
          console.log(data.orders); // لفحص البيانات
          if (data.success && data.orders) {
            setOrders(data.orders);
          }
        })
        .catch(err => console.error("Error fetching orders:", err));
    } else {
      navigate('/login');
    }
  }, [navigate]);

  return (
    <div className="orders-container">
      <h2>Orders</h2>
      <div className="orders-content">
        <div className="orders-table">
          <div className="orders-format-main">
            <p>Products</p>
            <p>Title</p>
            <p>Price</p>
            <p>Quantity</p>
            <p>Total</p>
          </div>
          <hr />

          {orders.length > 0 ? (
            orders.map((order, index) => (
              <div key={index} className="single-order">
                {order.items.map((item, itemIndex) => (
                  <div key={itemIndex} className="orders-format">
                    <img
                      src={item.image || 'https://via.placeholder.com/300'} // استخدام item.image من البيانات
                      alt={item.name}
                      className="orders-product-icon"
                    />
                    <p>{item.name}</p>
                    <p>${item.price}</p>
                    <p>{item.quantity} x {item.size}</p>
                    <p>${(item.price * item.quantity).toFixed(2)}</p>
                  </div>
                ))}

                <div className="orders-subtotal">
                  <hr />
                  <div className="orders-total-item">
                    <p><strong>Order {index + 1} Subtotal:</strong></p>
                    <p><strong>${order.total.toFixed(2)}</strong></p>
                  </div>
                  <hr />
                </div>
              </div>
            ))
          ) : (
            <p>No orders yet.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default Orders;
